import script from "./TrainerAcademyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainerAcademyPage.vue?vue&type=script&setup=true&lang=js"

import "./TrainerAcademyPage.vue?vue&type=style&index=0&id=3e32d3de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e32d3de"]])

export default __exports__